/* Mit Motiv · store fotos gøres mindre, før de sendes med til kurven (31/10-2026).
   Shopify afviser en kurv-tilføjelse over ca. 20 MB i alt («413 Request Entity Too Large»), og så kommer varen ikke i
   kurven. Det rammer fx PNG-fotos, 50-200 MP-fotos fra nye Android-telefoner og to store fotos på samme plakat.
   Fotos sendes uændret, når de tilsammen fylder højst 15 MB (det gælder næsten alle: median 0,8 MB i ordrerne i okt.).
   Ellers sendes en JPEG-kopi af de største fotos: højst 4096 px på den lange led (12,6 MP ved 4:3 — rigeligt til stilen
   og trykket, og under iPhones loft for et tegnelærred på 16,7 MP). Kan der ikke laves en kopi, og fylder fotoene stadig
   over 19,5 MB, stopper vi med en tydelig besked i stedet for Shopifys fejl.
   Bruges af plakatstudiet (mm-craft-studio.js) og af de almindelige produktsider (product-form.js) — samme kode i begge. */
(() => {
  if (window.MMFotoKrymp) return;
  const GRAENSE = 15e6;   // samlet størrelse, hvor vi begynder at gøre fotos mindre
  const LOFT = 19.5e6;    // over dette når fotoene aldrig frem (Shopifys loft er ca. 20 MB inkl. resten af formularen)
  const TRIN = [[4096, 0.9], [3072, 0.85], [2048, 0.85]];
  const en = () => /^en/i.test(document.documentElement.lang || '');
  const tekst = () => (en()
    ? 'Your photo is too large to send (over 20 MB). Please choose a smaller copy of the photo, e.g. a screenshot of it, and try again.'
    : 'Dit foto er for stort til at blive sendt (over 20 MB). Vælg en mindre udgave af fotoet, fx et skærmbillede af det, og prøv igen.');
  const netTekst = () => (en()
    ? 'The item was not added to your cart. Please check your connection and try again.'
    : 'Varen kom ikke i kurven. Tjek din forbindelse, og prøv igen.');
  const erFil = (v) => !!v && typeof v === 'object' && typeof v.size === 'number' && v.size > 0 && typeof v.type === 'string';
  const hent = (fil) => new Promise((res, rej) => {
    const url = URL.createObjectURL(fil);
    const im = new Image();
    im.onload = () => res({ im, url });
    im.onerror = () => { URL.revokeObjectURL(url); rej(new Error('kan ikke læse fotoet')); };
    im.src = url;
  });
  const tilBlob = (c, q) => new Promise((res) => {
    try { c.toBlob((b) => res(b), 'image/jpeg', q); } catch (e) { res(null); }
  });
  // den mindste JPEG-kopi, vi kan lave (stopper, så snart en kopi er under målet)
  const krymp = async (fil, maal) => {
    const { im, url } = await hent(fil);
    let bedst = null;
    try {
      const w0 = im.naturalWidth;
      const h0 = im.naturalHeight;
      if (!w0 || !h0) return null;
      for (const [lang, q] of TRIN) {
        const s = Math.min(1, lang / Math.max(w0, h0));
        const c = document.createElement('canvas');
        c.width = Math.max(1, Math.round(w0 * s));
        c.height = Math.max(1, Math.round(h0 * s));
        const g = c.getContext('2d');
        if (!g) break;
        g.fillStyle = '#fff';   // gennemsigtige områder i PNG bliver hvide, ikke sorte
        g.fillRect(0, 0, c.width, c.height);
        g.imageSmoothingQuality = 'high';
        g.drawImage(im, 0, 0, c.width, c.height);
        const b = await tilBlob(c, q);
        c.width = 0;            // frigiv lærredet med det samme (iPhone holder ellers på hukommelsen)
        c.height = 0;
        if (b && b.size && (!bedst || b.size < bedst.size)) bedst = b;
        if (bedst && bedst.size <= maal) break;
      }
    } finally {
      URL.revokeObjectURL(url);
    }
    if (!bedst) return null;
    const navn = String(fil.name || 'foto').replace(/\.[^.]*$/, '') + '.jpg';
    try { return new File([bedst], navn, { type: 'image/jpeg', lastModified: Date.now() }); } catch (e) { bedst.name = navn; return bedst; }
  };
  window.MMFotoKrymp = {
    tekst,
    netTekst,
    /* Gør formularens fotos mindre, hvis de tilsammen er for store til Shopify. Rører intet, når de er små nok.
       Kaster en fejl med kundens besked, hvis de stadig ikke kan sendes. */
    async formData(fd) {
      const antal = {};
      fd.forEach((v, k) => { if (erFil(v)) antal[k] = (antal[k] || 0) + 1; });
      const felter = Object.keys(antal).filter((k) => antal[k] === 1);   // samme feltnavn to gange røres ikke (set ville slå dem sammen)
      let sum = 0;
      fd.forEach((v) => { if (erFil(v)) sum += v.size; });
      if (sum <= GRAENSE) return false;
      const goer = async (k, maal) => {
        const f = fd.get(k);
        if (!erFil(f) || f.size <= maal) return;
        const lille = await krymp(f, maal).catch(() => null);
        if (lille && lille.size < f.size) {
          fd.set(k, lille, lille.name);
          sum += lille.size - f.size;
        }
      };
      // 1. runde: lige meget plads til hvert foto
      for (const k of felter) await goer(k, GRAENSE / felter.length);
      // 2. runde (sjælden — et foto kunne ikke læses, fx HEIC uden for Safari): de andre gøres endnu mindre
      for (const k of felter) if (sum > LOFT) await goer(k, Math.max(0.3e6, LOFT - 0.5e6 - (sum - fd.get(k).size)));
      if (sum > LOFT) throw new Error(tekst());
      return true;
    },
  };
})();

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        // Mit Motiv 31/10-2026: store fotos gøres mindre før afsendelse (over ca. 20 MB afviser Shopify dem med «413»,
        // og varen kom ikke i kurven — uden nogen besked). Fejl før svaret (for stort foto, intet net, et svar uden JSON)
        // vises nu for kunden i stedet for kun i konsollen. /root/mitmotiv-kurv-foto-20261031
        const mmK = window.MMFotoKrymp;
        const mmFejl = (tekst) => Object.assign(new Error(tekst), { mmKunde: true });
        const mmNet = () => (mmK ? mmK.netTekst() : 'Varen kom ikke i kurven. Prøv igen.');
        (mmK ? mmK.formData(formData) : Promise.resolve(false))
          .catch((e) => { throw mmFejl(e.message); })
          .then(() => fetch(`${routes.cart_add_url}`, config).catch(() => { throw mmFejl(mmNet()); }))
          .then((response) => {
            if (response.status === 413) throw mmFejl(mmK ? mmK.tekst() : 'Dit foto er for stort (over 20 MB).');
            return response.json().catch(() => { throw mmFejl(mmNet()); });
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            if (e && e.mmKunde) this.handleErrorMessage(e.message);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
